export const ALERT_COLORS = {
  SUCCESS: '#cfffcf',
  ERROR: '#ffe1db',
  NEUTRAL: '#ebe7e4',
  WARNING: '#fff2b9',
} as const;
